import { render } from "./DisapprovalComment.vue?vue&type=template&id=aa491318"
import script from "./DisapprovalComment.vue?vue&type=script&lang=js"
export * from "./DisapprovalComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__